import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const PRIORITIES = [
  ["baixa", "Baixa"], ["normal", "Normal"], ["alta", "Alta"], ["urgente", "Urgente"],
];

export default function TaskFormDialog({ open, onOpenChange, initialValue, members = [], membersUnavailable = false, stages = [], title = "Criar tarefa", onSubmit, saving = false }) {
  const [form, setForm] = useState(initialValue || {});
  useEffect(() => { if (open) setForm(initialValue || {}); }, [open, initialValue]);
  const set = (key, value) => setForm((current) => ({ ...current, [key]: value }));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-[#001533]" style={{ fontFamily: "Cabinet Grotesk" }}>{title}</DialogTitle>
        </DialogHeader>
        <form onSubmit={(event) => { event.preventDefault(); onSubmit(form); }} className="space-y-4">
          <div>
            <Label htmlFor="task-title">Título *</Label>
            <Input id="task-title" value={form.title || ""} onChange={(e) => set("title", e.target.value)} required className="mt-1.5 h-11 border-[#D1DEEE]" />
          </div>
          <div>
            <Label htmlFor="task-description">Descrição</Label>
            <Textarea id="task-description" value={form.descricao || ""} onChange={(e) => set("descricao", e.target.value)} rows={3} className="mt-1.5 border-[#D1DEEE]" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>Prioridade *</Label>
              <select value={form.prioridade || ""} onChange={(e) => set("prioridade", e.target.value)} required className="mt-1.5 h-11 w-full rounded-lg border border-[#D1DEEE] px-3 text-base text-[#001533] bg-white">
                <option value="" disabled>Confirmar prioridade</option>
                {PRIORITIES.map(([value, label]) => <option value={value} key={value}>{label}</option>)}
              </select>
            </div>
            <div>
              <Label htmlFor="task-deadline">Prazo *</Label>
              <Input id="task-deadline" type="date" value={form.data_limite || ""} onChange={(e) => set("data_limite", e.target.value)} required className="mt-1.5 h-11 border-[#D1DEEE]" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>Responsável</Label>
              <select value={form.responsavel_id || ""} onChange={(e) => set("responsavel_id", e.target.value || null)} className="mt-1.5 h-11 w-full rounded-lg border border-[#D1DEEE] px-3 text-base text-[#001533] bg-white">
                <option value="">Não atribuído</option>
                {members.map((member) => <option key={member.user_id} value={member.user_id}>{member.name || member.email}</option>)}
              </select>
              {membersUnavailable && <p className="text-xs text-[#6685AD] mt-1">Lista de responsáveis indisponível; usando a sugestão atual.</p>}
            </div>
            {stages.length > 0 && (
              <div>
                <Label>Etapa inicial</Label>
                <select value={form.stage_id || ""} onChange={(e) => set("stage_id", e.target.value)} className="mt-1.5 h-11 w-full rounded-lg border border-[#D1DEEE] px-3 text-base text-[#001533] bg-white">
                  {stages.map((stage) => <option key={stage.stage_id} value={stage.stage_id}>{stage.name}</option>)}
                </select>
              </div>
            )}
          </div>
          {(form.processo_id || form.intimacao_id) && (
            <div className="rounded-lg border border-[#D1DEEE] bg-[#F4F7FB] px-3 py-2 text-sm text-[#335480]">
              {form.processo_id && <p>Processo vinculado: <strong className="text-[#001533]">{form.processo_numero || form.processo_id}</strong></p>}
              {form.intimacao_id && <p>Origem: <strong className="text-[#001533]">Intimação vinculada</strong></p>}
            </div>
          )}
          <div className="flex justify-end gap-2 pt-1">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="border-[#D1DEEE]">Cancelar</Button>
            <Button type="submit" disabled={saving || !form.prioridade || !form.data_limite} className="bg-[#003882] hover:bg-[#00285e] text-white font-semibold">
              {saving ? "Salvando…" : "Criar tarefa"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
